import { Control, useWatch } from 'react-hook-form';

import { Enum, EnumListKey, useAllEnums } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

import { OverlappingEmpForm } from './useOverlappingEmploymentForm';

export const useEnumFilteredOptions = (
  control: Control<OverlappingEmpForm>,
  enumType: EnumListKey[],
): Enum[][] => {
  const { getEnums } = useAllEnums();
  const fEmpLegalEntityValue = useWatch({
    control,
    name: `overlappingEmployment.basicData.fEmpLegalEntity`,
  });

  const fEmpOrgUnitValue = useWatch({
    control,
    name: `overlappingEmployment.basicData.fEmpBusinessUnit1`,
  });

  const { legalEntities } = useAllLegalEntities();

  return enumType.map((type) =>
    filterActiveEnumsByCountryAndOrgUnits(
      getEnums(type),
      getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
      fEmpOrgUnitValue,
    ),
  );
};
